// ink-component
import React from 'react';

import getGlobalProps from '../../helpers/constants/global-props';

import { BlockquoteWrapper } from './styles';

export interface BlockquoteProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Use to quote or indent text that needs additional emphasis.
 */
function Blockquote(props: BlockquoteProps) {
  const { className, style, children, 'data-testid': dataTestId, ...otherProps } = props;

  return (
    <BlockquoteWrapper {...globalProps} {...otherProps} data-testid={dataTestId}>
      {children}
    </BlockquoteWrapper>
  );
}

Blockquote.defaultProps = {};

Blockquote.displayName = 'Blockquote';

export default Blockquote;
